import Vue from 'vue';
import generals from './json/generals.json';
import home from './json/home.json';
import careService from './json/careService.json';
import auth from './json/auth.json';
import stress from './json/stress.json';
import quicktest from './json/quickTest.json';
import intro from './json/intro.json';
import careLevelCalculator from './json/careLevelCalculator.json';
import taskScheduler from './json/taskScheduler.json';
import profile from './json/profile.json';
import careProfile from './json/careProfile.json';
import healthInsurances from './json/healthInsurances.json';
import contact from './json/contact.json';
import applications from './json/applications.json';
import edithcare from './json/edithcare.json';

const messages = {
  ...generals,
  ...home,
  ...careService,
  ...auth,
  ...stress,
  ...quicktest,
  ...intro,
  ...careLevelCalculator,
  ...taskScheduler,
  ...profile,
  ...careProfile,
  ...healthInsurances,
  ...contact,
  ...applications,
  ...edithcare,
};

function t(id, replace = {}) {
  let matchMsg = messages[id] || id;

  Object.keys(replace).map((key) => {
    matchMsg = matchMsg.replaceAll(`{${key}}`, replace[key]);
  });

  return matchMsg;
}

Vue.prototype.$t = t;

export default t;
